import script from "./BasicTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./BasicTemplate.vue?vue&type=style&index=0&id=3f7d90eb&lang=css"

const __exports__ = script;

export default __exports__